// angular
//     .module('HeroPRO')
//     .factory('BenjiUserFactory',

/* @ngInject */
export default function ($window, PartnerAppsFactory) {
    let isBenjiOnlyUser = false;
    let shouldBenjiRedirect = false;

    return {
        setIsBenjiUserOnly,
        getIsBenjiUserOnly,
        setShouldBenjiRedirect,
        getShouldBenjiRedirect,
        redirectUserToBenji,
        doNotRedirectOnAccountPages
    };

    function setIsBenjiUserOnly(isBenjiOnly) {
        if (typeof isBenjiOnly === 'boolean') {
            isBenjiOnlyUser = isBenjiOnly;
        }
        return this;
    }

    function getIsBenjiUserOnly() {
        return isBenjiOnlyUser;
    }

    function setShouldBenjiRedirect(benjiRedirect) {
        if (typeof benjiRedirect === 'boolean') {
            shouldBenjiRedirect = benjiRedirect;
        }
    }

    function getShouldBenjiRedirect() {
        return shouldBenjiRedirect;
    }

    function redirectUserToBenji() {
        $window.location.href = PartnerAppsFactory.getBenjiLink();
        return;
    }

    function doNotRedirectOnAccountPages() {
        const userOnAccountPages = document.location.pathname.indexOf("/accounts/") !== -1;

        if(userOnAccountPages) {
            setShouldBenjiRedirect(false);
        } else {
            setShouldBenjiRedirect(true);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/common/dataFactories/benjiUserFactory.js